export function createReducer(initialState, fnMap) {
  return (state = initialState, { type, payload, meta }) => {
    const handler = fnMap[type];

    return handler ? handler(state, payload, meta) : state;
  };
}
